import { Box } from '@mui/material'
import { Checkmark20Regular, Copy20Regular, Edit20Regular } from '@/components/Icon'
import UserChatBubbleVersionNav from './UserChatBubbleVersionNav'
import styles from './index.module.scss'

export default function UserChatBubbleBottomActions({
  isEditing,
  copied,
  handleCopy,
  onEdit,
  showVersionNav,
  versionLabel,
  onPrevVersion,
  onNextVersion,
  prevDisabled,
  nextDisabled,
}) {
  return (
    <Box className={`${styles.actions} ${isEditing ? styles.actionsHidden : ''}`} aria-hidden={isEditing}>
      <button
        type="button"
        className={styles.actionButton}
        aria-label="Copy message"
        tabIndex={isEditing ? -1 : 0}
        onClick={handleCopy}
      >
        {copied ? <Checkmark20Regular /> : <Copy20Regular />}
      </button>
      <button
        type="button"
        className={styles.actionButton}
        aria-label="Edit message"
        tabIndex={isEditing ? -1 : 0}
        onClick={() => onEdit?.()}
      >
        <Edit20Regular />
      </button>
      {showVersionNav ? (
        <UserChatBubbleVersionNav
          versionLabel={versionLabel}
          onPrevVersion={onPrevVersion}
          onNextVersion={onNextVersion}
          prevDisabled={prevDisabled}
          nextDisabled={nextDisabled}
          isEditing={isEditing}
        />
      ) : null}
    </Box>
  )
}
